const addRemoveGroup = {
  mixins: [mixins],
  props: {
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 4,
    },
    initial:{
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      items: Array(this.initial).fill(""),
    };
  },
  template: `<div>
    <slot :items="items" :add="add" :remove="remove" :min="min" :max="max" :randomKey="randomKey"></slot>  
  </div>`,
  methods: {
    add() {
      if (this.items.length < this.max) {
        this.items.push("");

        this.$nextTick(() => {
          this.update();
        });
      }
    },
    remove(index) {
      this.items.splice(index, 1);

      this.$emit("removed", index);
    },
    update() {
      this.$emit("updated", this.items);
    },
    randomKey(){
      return this.makeid()
    }
  },
};
